import { appNavigation } from "../../styles/appNavigation";
import IconHelper from "./IconHelper";

const UserIcon = (props) => (
  <IconHelper {...props} defaultWidth={24} defaultHeight={24}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="4.48106"
        cy="2.79887"
        rx="2.12315"
        ry="2.47172"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1"
      />
      <path
        d="M3.00485 5.88843C2.77598 6.07152 2.13974 6.49263 1.42569 6.71233C0.533125 6.98697 0.327148 7.26161 0.327148 8.15417C0.327148 9.04674 0.464466 10.2139 4.30937 10.2139C8.15427 10.2139 8.70354 8.90942 8.70354 8.15417C8.70354 7.39892 8.22293 7.05563 7.33036 6.71233C6.61631 6.4377 5.98007 6.04863 5.7512 5.88843"
        stroke={appNavigation.drawer.icon.color}
        strokeWidth="1"
      />
    </svg>
  </IconHelper>
);

export default UserIcon;
